import fetch from '@giro/shared-utils/fetch.util';

export default async function getApiPaymentLinksIdService(id: string) {
  return fetch(`payment-links/${id}`, {
    method: 'GET',
    ms: 'PDV',
    auth: true,
  });
}
